import { render } from "./backButton.vue?vue&type=template&id=a43cd484&scoped=true"
import script from "./backButton.vue?vue&type=script&lang=js"
export * from "./backButton.vue?vue&type=script&lang=js"

import "./backButton.vue?vue&type=style&index=0&id=a43cd484&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43cd484"]])

export default __exports__